import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommentsService } from '../../service/comments.service';
import {
  SimpleFilter,
  isSimpleFilter,
  predicateOperatorOptions,
  filterOptionsList,
  typeOptions,
  deepCopy
} from 'na-lib';

@Component({
    selector: 'app-work-task-template-filter-dialog',
    templateUrl: './work-task-template-filter-dialog.component.html',
    standalone: false
})
export class WorkTaskTemplateFilterDialogComponent {
  filterForm!: FormGroup
  operatorOptions = predicateOperatorOptions
  filterOptionsList = filterOptionsList
  typeOptions = typeOptions
  selectedType: string

  constructor(
    public dialogRef: MatDialogRef<WorkTaskTemplateFilterDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commentsService: CommentsService,
    private translate: TranslateService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      displayName: [],
      type: [],
      field: [],
      operator: ['=='],
      value: [],
      options: [[]]
    })

    this.filterForm.get('type')?.valueChanges.subscribe(value => {
      this.selectedType = value
    })

    if (this.data && this.data['filter']) {
      const filter = deepCopy(this.data.filter)
      if (isSimpleFilter(filter)) {
        this.selectedType = filter.type || undefined
        this.filterForm.patchValue({
          displayName: filter.displayName || undefined,
          type: filter.type || undefined,
          field: filter.field || undefined,
          operator: filter.operator || '==',
          value: filter.value !== undefined ? filter.value : undefined,
          options: filter.options || []
        })
      }
    }
  }

  onSave() {
    const formValues = this.filterForm.value
    const hasValue = formValues.value !== undefined && formValues.value !== null && formValues.value !== ''
    if (formValues.field && formValues.operator && (!this.data?.requireValue || hasValue)) {
      const filter: SimpleFilter = {
        field: formValues.field,
        operator: formValues.operator,
        value: formValues.value !== undefined && formValues.value !== null && formValues.value !== '' ? formValues.value : undefined,
      }

      if (formValues.displayName) {
        filter.displayName = formValues.displayName
      }

      if (formValues.type) {
        filter.type = formValues.type
      }

      if (formValues.options && formValues.options.length > 0) {
        filter.options = formValues.options
      }

      this.dialogRef.close([true, filter])
    } else {
      const message = this.translate.instant('SnackBarConstants.MANDATORY_FIELDS_EMPTY')
      this.commentsService.addSnackBar.emit(message)
    }
  }

  onCancel() {
    this.dialogRef.close([false])
  }
}
